import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const AIFeaturesSection = () => {
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);

  const features = [
    {
      icon: '🤖',
      title: 'AI Pest Detection',
      description: 'Advanced machine learning algorithms identify pests and diseases in real-time with 95%+ accuracy.',
      color: '#10B981',
    },
    {
      icon: '📊',
      title: 'Predictive Analytics',
      description: 'Forecast crop yields, weather patterns, and market trends to optimize your farming decisions.',
      color: '#3B82F6',
    },
    {
      icon: '🌱',
      title: 'Smart Monitoring',
      description: '24/7 automated monitoring of crops, soil conditions, and environmental factors.',
      color: '#8B5CF6',
    },
    {
      icon: '📱',
      title: 'Mobile Integration',
      description: 'Access your farm data anywhere, anytime with our comprehensive mobile platform.',
      color: '#F59E0B',
    },
    {
      icon: '🔔',
      title: 'Real-time Alerts',
      description: 'Instant sms notifications for critical issues, pest outbreaks, and maintenance needs.',
      color: '#EF4444',
    },
    {
      icon: '📈',
      title: 'Performance Insights',
      description: 'Detailed analytics and reports to track productivity and identify improvement areas.',
      color: '#06B6D4',
    },
  ];

  useEffect(() => {
    const ctx = gsap.context(() => {
      cardsRef.current.forEach((card, index) => {
        if (card) {
          gsap.from(card, {
            y: 80,
            opacity: 0,
            duration: 0.8,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: card,
              start: 'top 85%',
              toggleActions: 'play none none reverse',
            },
            delay: index * 0.1,
          });
        }
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="ai-features-section" id="features">
      <div className="features-container">
        <div className="section-header">
          <span className="section-label">AI Capabilities</span>
          <h2 className="section-title">
            Intelligent Features for
            <span className="gradient-text"> Modern Farming</span>
          </h2>
          <p className="section-description">
            Harness the power of our AI Pest disease detection system to revolutionize your agricultural operations
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              ref={(el) => (cardsRef.current[index] = el)}
              className="feature-card"
              style={{ '--accent-color': feature.color }}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
              <div className="feature-glow" style={{ background: feature.color }}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AIFeaturesSection;

